import { getStorage } from '@/utils/storage'

const ORDER_ACTION_ENUM = {
  CHANGE_SIGNATURE: 'CHANGE_SIGNATURE',
  REFUND: 'REFUND',
  CONTACT_CUSTOMER_SERVICE: 'CONTACT_CUSTOMER_SERVICE'
} // 订单页可操作性按钮枚举
export default {
  orderDetail: {},
  base_info: {}, // 基础数据
  offline_refund_info: {}, // 私退私改数据
  order_list: [], // 订单列表
  time_sequence: [], // 时间序列
  fee_info: [], // 费用信息
  coupon_info: {}, // 券信息
  other_info: {}, // 其他信息，包括温馨提示等信息
  total_info: {},
  voucher: {},
  approval_flow_list: [],
  approval_info: {},
  rc_info: [],
  remark_info: {},
  scramble_ticket_info: [],
  ORDER_ACTION_ENUM, // 订单页可操作性按钮枚举
  package_info: {}, // 加速包相关信息
  curProgress: 0, // 加速进度 进行缓存处理
  curSpeedStatus: 0, // 速度等级 进行缓存处理
  curScramebleStatus:{},
  tikcet_operate_drawer_info: {
    show: false,
    type: '',
    ticketId: '',
    segmentId: 0
  }, // 退改操作弹窗逻辑
  /**
   * @method 订单状态展示信息及支持操作内容配置
   *
   * @description zh 状态中文名称
   * @description detail 文案1 状态补充说明
   * @description tip 文案2 提示
   * @description action 可操作性内容项配置（改签、退票、联系客服）
   * @description showOrderId 订单号是否展示
   * @description loopTime 是否需要计算时间，0为不计算、>0为计算
   */
  /*
  1 - 已提交
  2 - 已预定 对应之前的已支付
  3 - 已支付
  4 - 已出票
  5 - 取消订单
  6 - 取消订单
  7 - 取消预定
  21 - 占座中
  22 - 出票中*/
  STATUS_ENUM: {
    1: {
      zh: '已提交',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    2: {
      zh: '已预定',
      detail: '',
      tip: '',
      icon: 'check-circle'
    },
    3: {
      zh: '已支付',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    4: {
      zh: '已出票',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    5: {
      zh: '取消订单',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    6: {
      zh: '取消订单',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    7: {
      zh: '取消预定',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    21: {
      zh: '占座中',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    },
    22: {
      zh: '出票中',
      detail: '',
      tip: '',
      icon: 'check-circle',
      showOrderId: true
    }

    //////
    // 1: {
    //   zh: '已完成',
    //   detail: '',
    //   tip: '',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 2: {
    //   zh: '待支付',
    //   detail: '占座成功',
    //   tip: '',
    //   icon: 'time',
    //   action: [],
    //   loopTime: 900 // s
    // },
    // 3: {
    //   zh: '已支付',
    //   detail: '',
    //   tip: '',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 4: {
    //   zh: '出票成功',
    //   detail: '',
    //   tip: '请凭身份证原件或12306App订单二维码进站乘车',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CHANGE_SIGNATURE, ORDER_ACTION_ENUM.REFUND, ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 5: {
    //   zh: '退票中',
    //   detail: '',
    //   tip: '',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 6: {
    //   zh: '订单关闭',
    //   detail: '',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 7: {
    //   zh: '改签待确认',
    //   detail: '占座成功',
    //   tip: '',
    //   icon: 'time',
    //   action: [],
    //   loopTime: 900 // s
    // },
    // 8: {
    //   zh: '改签中',
    //   detail: '',
    //   tip: '预计五分钟内出票完成，请注意短信提示',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 9: {
    //   zh: '已改签',
    //   detail: '',
    //   tip: '',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 11: {
    //   zh: '出票失败',
    //   detail: '支付费用将原路返回',
    //   tip: '',
    //   icon: 'exclamation-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE]
    // },
    // 14: {
    //   zh: '已退票',
    //   detail: '',
    //   detailTitle: '未退款',
    //   tip: '',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 15: {
    //   zh: '已退票',
    //   detail: '',
    //   detailTitle: '已退款',
    //   tip: '',
    //   icon: 'check-circle',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 21: {
    //   zh: '占座中',
    //   detail: '',
    //   tip: '',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE]
    // },
    // 22: {
    //   zh: '出票中',
    //   detail: '',
    //   tip: '预计五分钟内出票完成，请注意短信提示',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // },
    // 23: {
    //   zh: '改签占座中',
    //   detail: '',
    //   tip: '',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE]
    // },
    // 24: {
    //   zh: '改签出票中',
    //   detail: '',
    //   tip: '',
    //   icon: 'time',
    //   action: [ORDER_ACTION_ENUM.CONTACT_CUSTOMER_SERVICE],
    //   showOrderId: true
    // }
  } // 订单状态枚举
};
